import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "fridgedetailsselecthours-overlay" }
const _hoisted_2 = { class: "fridgedetailsselecthours-area" }
const _hoisted_3 = { class: "fridgedetailsselecthours-content" }
const _hoisted_4 = { class: "fridgedetailsselecthours-content-toolbar" }
const _hoisted_5 = { class: "fridgedetailsselecthours-content-toolbar-button-text" }
const _hoisted_6 = { class: "fridgedetailsselecthours-content-toolbar-button-text" }
const _hoisted_7 = { class: "fridgedetailsselecthours-content-drum" }
const _hoisted_8 = {
  class: "fridgedetailsselecthours-content-drum-scroll-content",
  ref: "hoursParentContent"
}
const _hoisted_9 = { class: "fridgedetailsselecthours-content-drum-scroll-content-item-text" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "fridgedetailsselecthours-content-drum-focus" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "fridgedetailsselecthours-content-drum-gradation-top" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "fridgedetailsselecthours-content-drum-gradation-bottom" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_Transition, { name: "fridgedetailsselecthours" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", {
                  class: "fridgedetailsselecthours-content-toolbar-button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickCancel(...args)))
                }, [
                  _createVNode("span", _hoisted_5, _toDisplayString(_ctx.cancelButtonText), 1)
                ]),
                _createVNode("div", {
                  class: "fridgedetailsselecthours-content-toolbar-button",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickSet(...args)))
                }, [
                  _createVNode("span", _hoisted_6, _toDisplayString(_ctx.setButtonText), 1)
                ])
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("div", {
                  class: "fridgedetailsselecthours-content-drum-scroll",
                  ref: "hoursScroll",
                  onScroll: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onScroll($event)))
                }, [
                  _createVNode("div", _hoisted_8, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hoursContent, (content) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "fridgedetailsselecthours-content-drum-scroll-content-item",
                        key: content.index
                      }, [
                        _createVNode("span", _hoisted_9, _toDisplayString(content.displayText), 1)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 512)
                ], 544),
                _hoisted_10,
                _hoisted_11,
                _hoisted_12
              ])
            ])
          ])
        ], 512), [
          [_vShow, _ctx.isShowSelectHours]
        ])
      ]),
      _: 1
    })
  ]))
}